import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: `/api/blocked_department`,
    name: 'POST_BLOCKED_DEPARTMENT',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
